import { render } from "./SubBanner.vue?vue&type=template&id=128c8cd2"
import script from "./SubBanner.vue?vue&type=script&lang=js"
export * from "./SubBanner.vue?vue&type=script&lang=js"

import "./SubBanner.vue?vue&type=style&index=0&id=128c8cd2&lang=scss"

import exportComponent from "/Users/Sacha/Projects/hnaccountancy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__